import { render, staticRenderFns } from "./smileColorful.vue?vue&type=template&id=56e4edab"
import script from "./smileColorful.vue?vue&type=script&lang=js"
export * from "./smileColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports